export const voiceAgent = {
  header: {
    title: "وكيل صوتي بالذكاء الاصطناعي",
    subBefore: "يرد على مكالماتك الهاتفية نيابةً عنك بالذكاء الاصطناعي في الوقت الفعلي. يسري على",
    subEmphasis: "حسابك بالكامل",
    active: "نشط",
    inactive: "غير نشط",
  },
  loading: "جارٍ تحميل الإعدادات…",
  errors: {
    load: "تعذّر تحميل الإعدادات.",
    save: "تعذّر الحفظ. حاول مرة أخرى.",
  },
  phone: {
    title: "رقم الهاتف",
    desc: "الرقم الذي يتصل به ضيوفك. يتم إنشاء رقم خاص بحسابك.",
    checking: "جارٍ التحقق من رقمك…",
    pendingTitle: "خدمة الهاتف في انتظار التفعيل",
    pendingText: "إنشاء الأرقام غير مُفعّل بعد في حسابك. راسِلنا وسنقوم بتفعيله.",
    activeCountry: "نشط · الدولة {country}",
    provisioning: "جارٍ التجهيز… (قد يستغرق بضع دقائق)",
    release: "تحرير",
    numberCountry: "دولة الرقم",
    searching: "جارٍ البحث…",
    seeAvailable: "عرض المتاح",
    perMonth: "{cost}/شهر",
    getThis: "احصل على هذا الرقم",
    getOne: "احصل على رقم",
    confirmRelease: "هل أنت متأكد من رغبتك في تحرير الرقم؟ سيتوقف عن استقبال المكالمات.",
    errNoneInCountry: "لا توجد أرقام متاحة في هذه الدولة حاليًا.",
    errTelnyxInactive: "خدمة الهاتف غير مُفعّلة بعد في حسابك.",
    errSearchFailed: "تعذّر البحث عن أرقام.",
    errTelnyxInactiveContact: "خدمة الهاتف غير مُفعّلة بعد في حسابك. راسِلنا وسنقوم بتفعيلها.",
    errNoNumbersNow: "لا توجد أرقام متاحة حاليًا.",
    errProvisionFailed: "تعذّر الحصول على الرقم.",
    errReleaseFailed: "تعذّر تحرير الرقم.",
  },
  voiceLang: {
    title: "الصوت واللغة",
    assistantVoice: "صوت المساعد",
    recommended: "(موصى به)",
    listenVoiceTitle: "استمع إلى صوت {voice}",
    loading: "جارٍ التحميل…",
    stop: "إيقاف",
    listen: "استماع",
    mainLanguage: "اللغة الرئيسية",
    extraLanguages: "لغات إضافية يمكنه التحدث بها",
    useIdentityTitle: "استخدام هوية وكيل المحادثة",
    useIdentityDesc: "يعيد استخدام الاسم والشخصية والنبرة التي حدّدتها مسبقًا في الإعدادات العامة.",
    voiceAssistantName: "اسم المساعد الصوتي",
    namePlaceholder: "مثال: استقبال Málaga Centro Suites",
    greeting: "تحية عند الرد",
    optional: "(اختياري)",
    greetingPlaceholder: "إذا تركته فارغًا، يحيّي المساعد تلقائيًا بهويته.",
    errPlayback: "تعذّر تشغيل العيّنة.",
    errGenerate: "تعذّر إنشاء عيّنة الصوت. حاول مرة أخرى.",
  },
  languages: {
    es: "الإسبانية",
    en: "الإنجليزية",
    fr: "الفرنسية",
    pt: "البرتغالية",
    it: "الإيطالية",
    de: "الألمانية",
    ar: "العربية",
  },
  countries: {
    ES: "إسبانيا",
    US: "الولايات المتحدة",
    GB: "المملكة المتحدة",
    FR: "فرنسا",
    IT: "إيطاليا",
    DE: "ألمانيا",
    PT: "البرتغال",
    CO: "كولومبيا",
    MX: "المكسيك",
  },
  days: {
    mon: "الإثنين",
    tue: "الثلاثاء",
    wed: "الأربعاء",
    thu: "الخميس",
    fri: "الجمعة",
    sat: "السبت",
    sun: "الأحد",
  },
  listings: {
    title: "أماكن الإقامة التي يرد عنها",
    desc: "اختر أماكن الإقامة التي يرد عنها الوكيل الصوتي في المكالمات.",
    all: "جميع أماكن الإقامة",
    some: "بعضها فقط",
    scopeNoteBefore: "يرد عن",
    scopeNoteStrong: "جميع",
    scopeNoteAfter: "أماكن الإقامة في الحساب، بما في ذلك ما تضيفه مستقبلاً.",
    searchPlaceholder: "ابحث عن مكان إقامة…",
    selectAll: "تحديد الكل",
    clearAll: "إزالة الكل",
    loadingListings: "جارٍ تحميل أماكن الإقامة…",
    noListings: "لا يحتوي هذا الحساب على أماكن إقامة.",
    noMatches: "لا توجد نتائج مطابقة.",
    noneWarn: "إذا لم تحدد أيًا منها، فسيرد الوكيل عن جميعها.",
    allDesc: "بما في ذلك ما تضيفه لاحقًا.",
    someDesc: "فقط ما تحدده أدناه.",
    selectedShort: "{n} من {total}",
  },
  capabilities: {
    title: "ما الذي يمكنه فعله",
    knowledgeTitle: "من أين يستقي معلوماته",
    knowledgeDesc: "اختر ما يرجع إليه المساعد عندما يُسأل عن مكان الإقامة.",
    messagesTitle: "تلقّي الرسائل",
    messagesDesc: "إذا لم يعرف شيئًا، يأخذ رسالة الضيف ويُعلمك بها.",
    linksTitle: "إرسال الروابط بعد المكالمة",
    linksDesc: "بعد إنهاء المكالمة، يرسل الرابط المفيد (تسجيل الوصول أو الحجز) عبر واتساب عند الاقتضاء.",
    photosTitle: "إرسال صور التجهيزات ووسائل الراحة",
    photosDesc: "إذا سأل المتصل عن وسيلة راحة لها صور، يرسلها الوكيل عبر واتساب إلى الرقم الذي يتصل منه.",
  },
  doc: {
    title: "مستند بالمعلومات",
    desc: "ارفع ملف PDF أو Word وسيتمكن الوكيل من الرد بما فيه.",
    dropTitle: "رفع مستند",
    dropHint: "PDF أو Word ‏(.docx)، حتى 15 ميغابايت",
    uploading: "جارٍ رفع المستند…",
    replace: "استبدال",
    remove: "إزالة",
    chars: "تمت قراءة {n} حرفًا",
    noText: "هذا المستند ممسوح ضوئيًا: إنه صور ولا يمكن قراءة النص. ارفع مستندًا بنص حقيقي.",
    errType: "يجب أن يكون الملف PDF أو Word ‏(.docx).",
    errSize: "لا يمكن أن يتجاوز الملف 15 ميغابايت.",
    errUpload: "تعذّر رفع المستند. حاول مرة أخرى.",
    errRemove: "تعذّر إزالة المستند. حاول مرة أخرى.",
    fuenteBase: "قاعدة المعرفة",
    fuenteBaseDesc: "بيانات أماكن إقامتك: تسجيل الوصول والخدمات والقواعد والأسئلة الشائعة.",
    fuenteDoc: "مستند خاص بك",
    fuenteDocDesc: "فقط ملف PDF أو Word الذي ترفعه هنا، بما فيه من تعليمات.",
    fuenteAmbas: "كلاهما",
    fuenteAmbasDesc: "المستند أولًا، وإذا لم تكن الإجابة فيه فبيانات مكان الإقامة.",
    verTexto: "عرض ما يقرأه المساعد",
    abrirOriginal: "فتح المستند",
    previewTitle: "ما يقرأه المساعد من مستندك",
    previewSub: "هذا هو النص المستخرج من الملف. إذا نقص شيء هنا فالمساعد لا يعرفه أيضًا.",
    previewVacio: "تعذّر استخراج نص من هذا الملف.",
    cerrar: "إغلاق",
    noUsado: "تم رفعه، لكن المساعد لا يستخدمه الآن: اخترت الرد بقاعدة المعرفة فقط.",
    faltaDoc: "ارفع مستندًا لتتمكن من اختياره كمصدر.",
  },
  hours: {
    title: "ساعات العمل",
    specific: "ساعات محددة",
    closed: "مغلق",
    afterHours: "خارج ساعات العمل",
    afterVoicemail: "أخذ رسالة صوتية",
    afterMessage: "تشغيل إشعار وإنهاء المكالمة",
    afterMessagePlaceholder: "الرسالة التي تُشغَّل خارج ساعات العمل.",
  },
  recording: {
    title: "التسجيل والامتثال",
    recordTitle: "تسجيل المكالمات",
    recordDesc: "يحفظ صوت المكالمات لتتمكن من مراجعتها.",
    noticeTitle: "الإشعار بالتسجيل",
    noticeDesc: "يُعلم المساعد في البداية بأن المكالمة قد تُسجَّل (موصى به وفقًا للائحة GDPR).",
    transcribeTitle: "تفريغ المكالمات نصيًا",
    transcribeDesc: "ينشئ نصًا لكل محادثة.",
    transcribeNeedsRecord: "يُستخرج النص من التسجيل الصوتي: مع إيقاف «تسجيل المكالمات» لا يُنشأ أي نص.",
  },
  advanced: {
    title: "متقدم",
    maxDuration: "الحد الأقصى لمدة المكالمة",
    minutesOption: "{n} دقيقة",
    aiEngine: "محرك الذكاء الاصطناعي",
  },
  save: {
    saved: "تم الحفظ ✓",
    save: "حفظ التغييرات",
    dirty: "لديك تغييرات غير محفوظة",
    clean: "تم حفظ كل شيء",
  },
  credits: {
    title: "دقائق المكالمات",
    desc: "دقائق مشمولة كل شهر حسب عدد إقاماتك. عند نفادها، أعد الشحن في أي وقت.",
    loading: "جارٍ تحميل الرصيد…",
    minutesLeft: "دقيقة متاحة",
    recharge: "إعادة شحن",
    includedThisMonth: "استُخدمت {used} من {total} دقيقة مشمولة هذا الشهر",
    purchased: "{min} دقيقة مشتراة",
    empty: "نفدت دقائقك. أعد الشحن لمواصلة استقبال المكالمات.",
    error: "تعذّر تحميل الرصيد.",
    modal: {
      title: "شحن الدقائق",
      sub: "اختر باقة. الدفع لمرة واحدة وتُضاف الدقائق إلى رصيدك فوراً.",
      pay: "الدفع بالبطاقة",
      secure: "دفع آمن عبر Stripe.",
      close: "إغلاق",
      error: "تعذّر بدء عملية الدفع. حاول مرة أخرى.",
    },
  },
};
